/** Import modules */

import { useEffect, useState } from "react";

import technicalPagesByLanguage from "../Pages/Technical";

/**
 * 
 * @returns Tyres product collection model
 * 
 */

const TechInfoModel = () => {

    const [ loading, setLoading ] = useState ( true ),

    [ data, setData ] = useState ( {

        technicalInformation: {

            edges: []

        }

    } );

    useEffect ( () => {

        let cancelled = false;

        const buildData = async () => {

            const flatPages = Object.entries ( technicalPagesByLanguage || {} ).reduce ( ( collection, [ language, pages ] ) => {

                if ( ! Array.isArray ( pages ) ) return collection;

                return collection.concat ( pages.map ( ( page, index ) => ( { language, page, index } ) ) );

            }, [] );

            const edges = await Promise.all ( flatPages.map ( async ( { language, page, index } ) => {

                const contentValue = typeof page?.content === "string" ? page.content : "";

                    const contentComponent =

                        typeof page?.contentComponent === "function"

                            ? page.contentComponent

                            : ( typeof page?.content === "function" ? page.content : null );

                return {

                    node: {

                        id: page?.id ? String ( page.id ) : `${ language }-${ index + 1 }`,

                        image: page?.image || "",

                        title: page?.title || "",

                        description: page?.description || "",

                            contentComponent,

                        content: contentValue,

                        isPublished: typeof page?.isPublished === "boolean" ? page.isPublished : true,

                        createdAt: page?.createdAt || null,

                        updatedAt: page?.updatedAt || null,

                        language: page?.language || language

                    }

                };

            } ) );

            if ( cancelled ) return;

            setData ( {

                technicalInformation: {

                    edges

                }

            } );

            setLoading ( false );

        };

        setLoading ( true );

        buildData ();

        return () => {

            cancelled = true;

        };

    }, [] );

    /** Return model */

    return { loading, data }

}

/** Export model */

export default TechInfoModel;